// extracted by mini-css-extract-plugin
export default {"button":"UiButton_button__gkycH","dark":"UiButton_dark__Oo-kM","light":"UiButton_light__ACEoD"};